import { combineLatest, fromEvent, Observable, of, Subject, concat, forkJoin } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';

/* 
    This is an custom web component for externally gotten HTML/JS/CSS. The reason for this
    is that we have no idea what might come in, it might have no js code or lots if its
    interactive. In previous version not using custom web component sometimes the interactivity
    would not work correct, still not sure why, but it seems to always work when doing it this way.
    This should also be a more secure way of loading in unknown js into mapview.
    This ensures that all of that lives in its own encapsulated environment away from mapview
    main app.
*/

class ExternalContentWrapper extends HTMLElement {
    set htmlContent(content) {
      this.innerHTML = content;
      //console.log("set htmlContent called")
      //console.log(content)
      this.executeScripts()
    }

    connectedCallback() {
        //console.log("CONNECTED CONNECTED CONNECTEDEED")
    }

    disconnectedCallback() {
        //console.log("I WAS KILLED")
    }

    executeScripts() {
        const allScriptElements= Array.from(this.querySelectorAll("script"))
        const scriptLibraries = allScriptElements.filter(s => s.hasAttribute("src"))
        const scriptSourceCode = allScriptElements.filter(s => !s.hasAttribute("src"))

        //console.log("ScriptLibraries: ")
        //console.log(scriptLibraries)
        //console.log("script source code: ")
        //console.log(scriptSourceCode)

        const scriptLibsLoaded$ = scriptLibraries.map(sl => this.loadSingleScriptElement(sl))
        if (scriptLibraries.length > 0) {
            combineLatest(scriptLibsLoaded$).pipe(take(1)).subscribe((libsLoaded) => {
                scriptSourceCode.forEach(ssc => this.loadSingleScriptElement(ssc))
            })
        } else {
            scriptSourceCode.forEach(ssc => this.loadSingleScriptElement(ssc))
        }
        
    }

     /*
        From https://stackoverflow.com/questions/2592092/executing-script-elements-inserted-with-innerhtml and adapted for mapview needs.
        Take is an HTML element thats already in the DOM and a string of HTML code.
        Replace all script tags with new ones in the HTML and executes in order (libraries/modules first, then user scripts).
        Returns an observable, which contains the ready HTML in string form. It returns this after it has executed all the script tags.
    */
    /*
      Takes in a single script element, creates a brand new script elment with the same attributes as from the old one.
      Then extracts the source code from the old script tag via document.createTextNode(oldScriptEl.innerHTML) and
      puts it into the new script tag as a child. The script tag gets executed with replaceChild() !

      Returns an observable which will emit once the script tag has finished loading.
    */
    loadSingleScriptElement(oldScriptEl) {
        //For each script element in innerHTML, create a new fresh one.
        const newScriptEl = document.createElement("script")
        /*
        All scripts that are created dynamically like here have async = true as a default, however we need to execute these 
        scripts in order, thats why I put async to false here. If this was not here we would sometimes get errors when 1 script
        is loaded&executed faster than some other, but it depends on the other so we get an error.
        */
        newScriptEl.async = false
        
        //Set the same attributes from the old one to the new one
        Array.from(oldScriptEl.attributes).forEach( attr => {
            newScriptEl.setAttribute(attr.name, attr.value)
            //console.log(`attr.name: ${attr.name} | attr.value: ${attr.value}`) 
        });
        
        //Extract only the text(source code) from a single old script element
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        //Set it on the new script element
        newScriptEl.appendChild(scriptText);
        
        newScriptEl.textContent = oldScriptEl.textContent
        //console.log(scriptText)

        const loaded$ = fromEvent(newScriptEl, "load", {once: true})
        
        //newScriptEl.onload = (event) => {
            //console.log("Script tag loaded!")
            //console.log(newScriptEl)
            //console.log(event)
        //}
        
        //Finally replaces the old script tag with the new one we just created.
        //This is what actually executes the code it seems...
        //this.replaceChild(newScriptEl, oldScriptEl);
        oldScriptEl.replaceWith(newScriptEl)
        
        return loaded$
        
    }
  }
  
  customElements.define('external-content-wrapper', ExternalContentWrapper);